'use strict';
/*
* footer scroll btn
* @package krobot
* @deps jquery
*/
const $ = jQuery;

$( '.js-sub-toggle .menu-item-has-children > a' ).on( 'click keypress', function() {
	$( this ).next( '.sub-menu' ).slideToggle( 300 );
	$( this ).toggleClass( 'on' );
	return false;
} );
